import { createFileRoute } from "@tanstack/react-router";
import { browseDogsAdoptRoute } from "@/app-clients/browse-dogs";

export const Route = createFileRoute("/adopt")({
    beforeLoad: browseDogsAdoptRoute.beforeLoad,
    component: () => null,
});
